"use client";
import React from "react";
const Context = React.createContext({});
export const TabsProvider = Context.Provider;
export const useTabs = (value) => {
    const { id, ...data } = React.useContext(Context);
    return {
        ...data,
        panelId: value !== undefined ? `${id}-tabs-panel-${value}` : undefined,
        buttonId: value !== undefined ? `${id}-tabs-button-${value}` : undefined,
    };
};
